import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/App';
import './index.css';
import './shared/lib/theme.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

